<template>
  <div style="margin: 0px 30px">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <div style="direction: initial" class="md-layout mt-25">
      <div class="md-layout-item md-size-100">
        <h4 style="font-weight: 100" class="text-center">
          {{ allData.fullName }}
        </h4>
        <h4 style="font-weight: 100" class="text-center">
          {{ allData.shortName }}
        </h4>
        <h3 class="text-center">شهادة المرتب</h3>
      </div>

      <div class="md-layout-item md-size-100">
        <h4 class="text-left" style="margin-left: 84px">
          التاريخ : {{ convert(date) }}
        </h4>
        <h4 class="text-left" style="margin-left: 100px">: الرقم الإشاري</h4>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header
            style="margin-bottom: 30px"
            class="md-card-header-text md-card-header-green"
          >
            <div class="card-text">
              <h4 class="title">شهادة المرتب</h4>
            </div>
          </md-card-header>

          <div style="margin: 10px 20px 10px 10px" class="md-layout">
            <div class="md-layout-item md-size-30 ml-15">
              <md-field>
                <label>الاسم</label>
                <md-input disabled v-model="allData.employeeName"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 ml-15">
              <md-field>
                <label>الرقم الوطني</label>
                <md-input disabled v-model="allData.nationalNumber"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 ml-15">
              <md-field>
                <label>رقم الموظف</label>
                <md-input disabled v-model="allData.jobNumber"></md-input>
              </md-field>
            </div>

            <div
              v-if="privateCompanyMode == 'false' || !privateCompanyMode"
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>الدرجة الوظيفية</label>
                <md-input disabled v-model="allData.degree"></md-input>
              </md-field>
            </div>

            <div
              v-if="privateCompanyMode == 'false' || !privateCompanyMode"
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>العلاوة</label>
                <md-input disabled v-model="allData.bonuse"></md-input>
              </md-field>
            </div>

            <div
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>المصرف</label>
                <md-input disabled v-model="allData.bankBranchName"></md-input>
              </md-field>
            </div>

            <div
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>رقم الحساب</label>
                <md-input disabled v-model="allData.accountNumber"></md-input>
              </md-field>
            </div>

            <div
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>الوظيفة</label>
                <md-input disabled v-model="allData.job"></md-input>
              </md-field>
            </div>

            <div
              style="margin-top: 30px"
              class="md-layout-item md-size-30 ml-15"
            >
              <md-field>
                <label>صافي المرتب</label>
                <md-input disabled v-model="allData.netSalary"></md-input>
              </md-field>
            </div>

            <div
              style="margin-top: 30px"
              class="md-layout-item md-size-90 ml-15"
            >
              <md-field>
                <label>صافي المرتب بالحروف</label>
                <md-input disabled v-model="allData.netSalaryString"></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>بيان الإضافة</md-table-cell>

                    <md-table-cell>القيمة</md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell md-label="الصنف"
                      >المرتب الأساسي</md-table-cell
                    >

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.basicSalary)
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell md-label="الصنف"
                      >العمل الإضافي</md-table-cell
                    >

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.overTimeValue)
                    }}</md-table-cell>
                  </md-table-row>

                  <template v-if="allData.detailedReport">
                    <md-table-row
                      v-for="reward in allData.rewards"
                      :key="reward.id"
                    >
                      <md-table-cell md-label="الصنف">{{
                        reward.rewardName
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        formatValues(reward.value)
                      }}</md-table-cell>
                    </md-table-row>
                  </template>

                  <template v-if="allData.detailedReport">
                    <md-table-row
                      v-for="allowance in allData.allowances || []"
                      :key="allowance.id"
                    >
                      <md-table-cell md-label="الصنف">{{
                        allowance.typesBonus || allowance.typesBonuse
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        formatValues(allowance.value)
                      }}</md-table-cell>
                    </md-table-row>
                  </template>

                  <md-table-row v-if="!allData.detailedReport">
                    <md-table-cell md-label="الصنف">علاوات أخرى</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.totalAllowances)
                    }}</md-table-cell>
                  </md-table-row>

                  <md-table-row>
                    <md-table-cell md-label="الصنف">الإجمالي</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.totalSalary)
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>

            <pre></pre>

            <div class="md-layout-item md-size-50">
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>بيان الإستقطاع</md-table-cell>

                    <md-table-cell>القيمة</md-table-cell>
                  </md-table-row>
                  <md-table-row
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  >
                    <md-table-cell md-label="الصنف"
                      >الإشتراكات الضمانية</md-table-cell
                    >

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.warrantyTax)
                    }}</md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  >
                    <md-table-cell md-label="الصنف">حصة التضامن</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.solidarityTax)
                    }}</md-table-cell>
                  </md-table-row>

                  <md-table-row>
                    <md-table-cell md-label="الصنف"
                      >خصم الغياب والتأخير</md-table-cell
                    >

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.absanceDiscount)
                    }}</md-table-cell>
                  </md-table-row>

                  <!-- <template v-if="allData.deductions.length > 0"> -->
                  <template v-if="allData.detailedReport">
                    <md-table-row
                      v-for="deduction in allData.deductions"
                      :key="deduction.id"
                    >
                      <md-table-cell md-label="الصنف">{{
                        deduction.deductionTypeName
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        formatValues(deduction.monthlyCredit)
                      }}</md-table-cell>
                    </md-table-row>
                  </template>
                  <template v-if="!allData.detailedReport">
                    <md-table-row>
                      <md-table-cell md-label="الصنف"
                        >الاستقطاعات</md-table-cell
                      >

                      <md-table-cell md-label="الصنف">
                        {{ allData.deductionValue }}
                      </md-table-cell>
                    </md-table-row>
                  </template>

                  <md-table-row>
                    <md-table-cell md-label="الصنف">خصميات أخرى</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.otherDiscounts)
                    }}</md-table-cell>
                  </md-table-row>

                  <md-table-row>
                    <md-table-cell md-label="الصنف">الإجمالي</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(allData.totalDiscount)
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </div>

          <div
            class="bord"
            style="
              direction: ltr;
              border: 2px solid rgb(67, 160, 71);
              background: #fbfbfb;
              margin-top: 50px;
              margin-right: 70px;
              margin-left: 100px;
              margin-bottom: 50px;
            "
          >
            <div style="direction: rtl" class="md-layout">
              <div
                style="text-align: center"
                class="md-layout-item md-size-100"
              >
                <h4>
                  أعطيت هذه الشهادة بناء على طلبه لاستعمالها في الأغراض المسموح
                  بها قانونا
                </h4>
              </div>
            </div>

            <div class="md-layout mt-25 text-center">
              <div style="text-align: start" class="md-layout-item md-size-40">
                <p style="font-weight: bold">يعتمد رئيس قسم الشؤون المالية</p>
                <p style="font-weight: bold; margin-left: 158px">: التوقيع</p>
              </div>

              <div class="md-layout-item md-size-40" style="text-align: end">
                <p style="font-weight: bold">معد الشهادة</p>
                <p style="font-weight: bold">: الإسم</p>
                <p style="font-weight: bold">: التوقيع</p>
              </div>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["allData", "date"],
  data() {
    return {
      privateCompanyMode: false,
      m: env.mTop(),
    };
  },

  async created() {
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  methods: {
    formatValues(value) {
      if (value) {
        return value.toLocaleString();
      }
      return value;
    },
    convert(event) {
      try {
        if (!event) {
          return "-";
        }
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()
          // + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/employeeCard";

.bord {
  border: 1px solid #000;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 14px;
}

.t-body {
  direction: rtl;
}
</style>
